import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "9a76398a-8f85-4aac-be86-1518c0df95cd",
    authority: "https://login.microsoftonline.com/d6a975ac-66de-46cc-8cf4-79991832f2b7",
    redirectUri: "http://localhost:3000",
  },
};